import { Environment } from 'projects/shared/src/lib/models/environment.model';
import { environment as ETSe } from 'ets-fe-ng-sdk';

export const environment = new Environment(true, 'Evolutics Staging');
// environment.userCompanyCode='C1'
environment.apiBaseUrl = `https://naicom-service.evoluticstech.com/naicom-service/api/`;
environment.apiWorkflowBaseUrl = `https://naicom-workflow-service.evoluticstech.com/workflow-service/api/`;
environment.apiGatewayBaseUrl = `https://naicom-gateway-service.evoluticstech.com/naicom-gateway-service/api/`;
environment.apiMessagingBaseUrl = `https://naicom-messaging-service.evoluticstech.com/messaging-service/api/`;
environment.apiUserServiceBaseUrl = `https://naicom-user-service.evoluticstech.com/naicom-user-service/api/`;
ETSe.reinit(environment);
